{
  "note": "web-app's copy of the answer ceiling core publishes (marketing-website/contracts/concierge-answer-ceiling.json). Two keys, both whole milliseconds: completion_ceiling_ms, how long core lets the model answer, and write_margin_ms, its handler's margin on top. client.ts waits this long for a Jarvis answer, plus network slack. scripts/check-answer-ceiling.mjs fails CI while this copy differs from the published one, so take both numbers from there. JAR-2022.",
  "completion_ceiling_ms": 600000,
  "write_margin_ms": 30000
}
